import { useCompletion } from "ai/react";
import TypingText from "../markdown/TypingText";
import { useEffect } from "react";
import { environment, nextJsEndpoint } from "../../../taskpane/utils/constants";
import TypingIndicator from "../markdown/TypingIndicator";
const shortSummaryURL = nextJsEndpoint[environment] + "/api/opinion/{{opinion_id}}/summary?type=short";

export const ShortSummaryContainer = ({ opinionId }: { opinionId?: string }) => {
  const shortSummaryUrl = shortSummaryURL.replace("{{opinion_id}}", opinionId ?? "");

  const {
    completion: completionShortSummary,
    isLoading: isLoadingShortSummary,
    complete: completeShortSummary,
  } = useCompletion({
    api: shortSummaryUrl,
  });

  useEffect(() => {
    if (opinionId) completeShortSummary("");
  }, [opinionId]);

  return isLoadingShortSummary ? <TypingIndicator /> : <TypingText text={completionShortSummary}></TypingText>;
};
